import { auditReports } from '@mi-front/api-clients';
import { QueryView } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { Page } from '../../../../../../components/page/Page';
import { AodBreadcrumbs } from '../../components/AodBreadcrumbs';
import { aodRoutes } from '../../routing/routes';
import { AodRuleEditWizard } from './AodEditRuleWizard';

export function AodRuleEditPage() {
  const { id } = useParams<{ id: string }>();
  const { formatMessage } = useIntl();

  const ruleQuery = auditReports.useGetOneBaseAodRulesControllerAodRule(id);

  const title = formatMessage({
    id: 'audit.aod.rules.editScreen.title',
    defaultMessage: 'Editar regla AOD',
  });

  return (
    <QueryView query={ruleQuery}>
      {(rule) => (
        <Page htmlTitle={title}>
          <Page.Header
            title={title}
            breadcrumbs={
              <AodBreadcrumbs
                items={[
                  {
                    href: aodRoutes.ruleView.gen(id),
                    content: rule.name,
                  },
                ]}
              />
            }
          />
          <Page.Content>
            <AodRuleEditWizard rule={rule} />
          </Page.Content>
        </Page>
      )}
    </QueryView>
  );
}
